<template>
<div class="chapter">
<div class="inner_page">
<p class="praise"><a id="page_i"></a><a id="page_ii"><span class="txbfit">Once, they lived in the shadows of their famous husbands.</span></a></p><a id="page_ii">
<p class="praise1"><span class="txbfit">Now, Hollywood wives are taking control. . . .</span></p>
<p class="praise2"><span class="txbf">Praise for Jackie Collins and her page-turning <span class="txbfit">New York Times</span> bestseller</span></p>
<p class="praise3"><span class="txbfit">HOLLYWOOD WIVES: THE NEW GENERATION</span></p>
<p class="praise4">“Luststyles of the rich and famous. . . . The true intrigue is in trying to figure out what real Hollywood characters Collins is caricaturing.”</p>
<p class="praiser"><span class="txit">—People</span></p>
<p class="praise4">“[This] glam take on celebrity fashion and open sexuality make it perfect fodder for our <span class="txit">Sex and the City</span> era.”</p>
<p class="praiser"><span class="txit">—Entertainment Weekly</span></p>
<p class="praise4">“[A] twisted plot.”</p>
<p class="praiser"><span class="txit">—Daily News</span> (New York)</p>
<p class="praise4">“Collins is a natural-born storyteller, a writer with an instinctive gift for racing narrative that is as willfully chaotic as anything in life.”</p>
<p class="praiser"><span class="txit">—Los Angeles Times</span></p>
<p class="praise4">“Collins at her page-turning best.”</p>
<p class="praiser"><span class="txit">—The Palm Beach Post</span> (FL)</p>
<p class="praise4">“Sizzling. . . . Collins dishes up glamour, suspense, and heartache.”</p>
<p class="praiser"><span class="txit">—Good Housekeeping</span></p>
<p class="praise4">“This is Collins at her ultra-celeb, super-accessorized, best-selling best.”</p>
<p class="praiser"><span class="txit">—Publishers Weekly</span></p>
<p class="praise4">“Patented Jackie Collins.”</p>
<p class="praiser"><span class="txit">—The Orlando Sentinel (FL)</span></p>
<p class="praise5"><span class="txbf">Also available from Simon &amp; Schuster Audio—read by the author!</span></p>
</a><p class="praise6"><a id="page_ii"></a><a id="page_iii"><span class="txbfit">Madison Castelli, the glamorous and street-smart heroine of Jackie Collins’ miniseries</span> <span class="txbf">L.A. Connections,</span> <span class="txbfit">sets the night on fire in two sizzling bestsellers</span></a></p><a id="page_iii">
<p class="praise2"><span class="txbfit">DEADLY EMBRACE</span></p>
<p class="praise4">“The godmother of glam/vamp fiction. . . . Collins knows no limits.</p>
<p class="praiser">—<span class="txit">Publishers Weekly</span></p>
<p class="praise4"><span class="txit">“Deadly Embrace</span> starts with a bang. . . . Plenty of sex, suspense, revenge, passion, intrigue, and deception.”</p>
<p class="praiser"><span class="txit">—The Times Union</span> (Albany, NY)</p>
<p class="praise4">“This book has everything—a restaurant hold-up, unfaithful wives, movie stars, sex, and murder.”</p>
<p class="praiser">—Liz Smith, <span class="txit">New York Post</span></p>
<p class="praise4">“Jackie Collins is one incredible storyteller.”</p>
<p class="praiser"><span class="txit">—The Anniston Star</span> (AL)</p>
<p class="praise4">“[A] dishy page-turner, <span class="txit">Deadly Embrace,</span> will doubtless find its way into every Prada beach bag from coast to coast.”</p>
<p class="praiser"><span class="txit">—Hamptons Magazine</span></p>
<p class="praise4">“[A] sex-o-rama. . . . Brisk and fast-paced. . . . It’s all very addictive.”</p>
<p class="praiser">—Associated Press</p>
<p class="praise2"><span class="txbfit">LETHAL SEDUCTION</span></p>
<p class="praise4">“Cool as a subzero shot of designer vodka.”</p>
<p class="praiser"><span class="txit">—Kirkus Reviews</span></p>
<p class="praise4">“[A] bawdy, boisterous lust fest from Collins.”</p>
<p class="praiser">—<span class="txit">People</span></p>
</a><p class="praise4"><a id="page_iii"></a><a id="page_iv">“Even the tiniest nuances of naughtiness rarely escape the author’s anthropological eye. . . . Decadence, luxury, and film-land plot lines that make Collins one of the bestselling writers of our time.”</a></p><a id="page_iv">
<p class="praiser">—<span class="txit">Los Angeles Times</span></p>
<p class="praise4">“Vicarious thrills.”</p>
<p class="praiser">—<span class="txit">Booklist</span></p>
<p class="praise4">“Collins injects plenty of glamour into this page-flipping tale”</p>
<p class="praiser">—<span class="txit">Publishers Weekly</span></p>
<p class="praise4">“No one writes a better sex-in-the-back-of-a-Bentley scene.”</p>
<p class="praiser">—<span class="txit">Talk</span></p>
<p class="praise4">“The literary guilty pleasure is defined once again by Jackie Collins’ <span class="txit">Lethal Seduction</span> . . . a frothy romp packed with gorgeous people obsessed with sex, deception, cash, and more sex. . . . Fans should give in to Collins’ seduction.”</p>
<p class="praiser"><span class="txit">—Us</span> magazine</p>
<p class="praise4">“Crackles with light, beach-ready scandal and suspense.”</p>
<p class="praiser"><span class="txit">—The Village Voice</span></p>
<p class="praise7"><span class="txbf">“JACKIE COLLINS’ BOOKS ARE HOT AND STEAMY . . . ENOUGH OVERHEATED SEX AND ACTION [TO PUT] POLAR ICE CAPS IN DANGER OF MELTDOWN.”</span></p>
<p class="praiser"><span class="txbfit">—Houston Post</span></p>
<p class="praise7"><span class="txbf">“A LOT OF THE FUN OF READING COLLINS’ SCORCHERS HAS ALWAYS BEEN TRYING TO IDENTIFY THE REAL PEOPLE ON WHOM THE FICTIONAL ONES ARE BASED.”</span></p>
<p class="praiser"><span class="txbfit">—Chicago Tribune</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?d1e4f8dc